import AllContextProvider from '#Context/AllContext'
import Scaffolding from './Scaffolding'
import Home from '#Pages/Home'
// import Infrastructure from './Infrastructure'

import './base.css'

export default {
    AllContextProvider,
    Scaffolding,
    Home,
    // Infrastructure
}